import React from "react";
import { Box, Theme, Typography, useTheme } from "@mui/material";
import { SxStyleSheet } from "../../themes/_base";

export interface IndexedTitleProps {
  index?: number | string;
  title: string;
  withMargin?: boolean;
  negative?: boolean;
}

export const IndexedTitle = ({
  index,
  title,
  withMargin,
  negative,
}: IndexedTitleProps) => {
  const theme = useTheme();
  const styles = getStyles(theme, withMargin, negative);

  return (
    <Box sx={styles.box}>
      {!!index && <Typography sx={styles.index}>{index}</Typography>}
      <Typography sx={styles.title}>{title}</Typography>
    </Box>
  );
};

const getStyles = (
  theme: Theme,
  withMargin?: boolean,
  negative?: boolean
): SxStyleSheet => ({
  box: {
    display: "flex",
    alignItems: "center",
    marginTop: withMargin ? theme.spacing(2) : 0,
  },
  index: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: negative ? theme.palette.primary.main : theme.palette.common.white,
    backgroundColor: negative
      ? theme.palette.common.white
      : theme.palette.primary.main,
    border: negative ? `1px solid ${theme.palette.primary.main}` : "none",
    borderRadius: "50%",
    fontWeight: "bold",
    fontSize: 12,
    height: 20,
    width: 20,
    marginRight: theme.spacing(0.5),
  },
  title: {
    fontWeight: "bold",
  },
});
